import { useListItem } from '@floating-ui/react'
import clsx from 'clsx'
import { ReactNode } from 'react'
import { useSelectContext } from './SelectContext'
import styles from './SelectOption.module.scss'

export interface SelectOptionProps {
  id: string
  children: ReactNode
  icon?: ReactNode
  disabled?: boolean
}

export const SelectOption = ({ children, id, icon, disabled }: SelectOptionProps) => {
  const { activeIndex, selectedIndexes, getItemProps, handleSelect, size } = useSelectContext()
  const { ref, index } = useListItem({ label: id })

  const isActive = activeIndex === index
  const isSelected = selectedIndexes.includes(index)

  return (
    <li
      ref={ref}
      role="option"
      aria-selected={isSelected}
      tabIndex={isActive ? 0 : -1}
      className={clsx('mui-select-option-wrapper', styles.option, styles[size], {
        [styles.active]: isActive,
        [styles.selected]: isSelected,
        [styles.disabled]: disabled,
      })}
      {...getItemProps?.({
        onClick: () => handleSelect(index),
      })}
    >
      {icon}
      <div className={clsx('mui-select-option-children', styles.children)}>{children}</div>
    </li>
  )
}
